import React from 'react';
import Contacts from '../../Components/Contacts/contacts.js';
import Form from "../../Components/Form/form.js";

function ContactsPage() {
  return (
    <>
    <Contacts />
    <Form />
    </>
  )
}

export default ContactsPage ;